import { AnyAction } from '@reduxjs/toolkit';
import * as entityHandlers from '../../../modules/bin/entityHandlers';
import { GridOptions } from '../../../components/common/grid/gridOptions';
import ColumnModel from '../../../components/common/grid/columnModel';
import { Record } from '../../../modules/bin/utility';
import { CLEAR } from '../../../modules/general';
import {
  accessKeyColumnData,
  accessKeyDefaultOrderBy,
  accessKeysAvailableFiltersKeys
} from '../../../constants/accessKey';
import update from '../../../helpers/update';
import {
  ACCESS_KEYS_METADATA_REQUESTED,
  ACCESS_KEYS_METADATA_SUCCESS,
  ACCESS_KEYS_METADATA_FAILURE,
  ACCESS_KEYS_LIST_DATA_REQUESTED,
  ACCESS_KEYS_LIST_DATA_SUCCESS,
  ACCESS_KEYS_LIST_DATA_FAILURE,
  ACCESS_KEYS_CREATE_REQUESTED,
  ACCESS_KEYS_CREATE_SUCCESS,
  ACCESS_KEYS_CREATE_FAILURE,
  ACCESS_KEYS_DELETE_REQUESTED,
  ACCESS_KEYS_DELETE_SUCCESS,
  ACCESS_KEYS_DELETE_FAILURE,
  ACCESS_KEYS_MESSAGE_CLEAR,
  ACCESS_KEYS_DISABLE_CONFIRMATION_SHOW,
  ACCESS_KEYS_DISABLE_CONFIRMATION_HIDE
} from './accessKeyTypes';

const initialState = {
  timestamp: new Date().getTime(),
  accessKeysList: new GridOptions()
    .addColumns(
      accessKeyColumnData.map(
        (x) =>
          new ColumnModel(x.path, x.header, x.customFormatter).setVisible(
            x.defaultVisible
          )
      )
    )
    .orderBy(accessKeyDefaultOrderBy.path, accessKeyDefaultOrderBy.order)
    .addAvailableFiltersKeys(accessKeysAvailableFiltersKeys)
    .getState(),
  record: Record.getDefaultState(),
  recordCreate: Record.getDefaultState()
};

const accessKeyReducer = (state = initialState, action: AnyAction) => {
  let newState = state;
  switch (action.type) {
    case CLEAR:
    case ACCESS_KEYS_DELETE_SUCCESS:
      newState = initialState;
      break;
    case ACCESS_KEYS_METADATA_REQUESTED:
      newState = entityHandlers.metadataRequestedHandler(state, action);
      break;
    case ACCESS_KEYS_METADATA_SUCCESS:
      newState = entityHandlers.metadataSuccessHandler(state, action);
      break;
    case ACCESS_KEYS_LIST_DATA_REQUESTED:
      newState = entityHandlers.listDataRequestedHandler(state, action);
      break;
    case ACCESS_KEYS_LIST_DATA_SUCCESS:
      newState = entityHandlers.listDataSuccessHandler(state, action);
      break;
    case ACCESS_KEYS_LIST_DATA_FAILURE:
      newState = entityHandlers.listDataFailureHandler(state, action);
      break;
    case ACCESS_KEYS_MESSAGE_CLEAR:
      newState = entityHandlers.crudClearErrorHandler(state, action.payload.key);
      break;
    case ACCESS_KEYS_METADATA_FAILURE:
      newState = entityHandlers.listMetadataFailureHandler(state, action);
      break;
    case ACCESS_KEYS_CREATE_REQUESTED:
    case ACCESS_KEYS_DELETE_REQUESTED:
      newState = entityHandlers.getRecordRequestedHandler(state, action);
      break;
    case ACCESS_KEYS_CREATE_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      break;
    case ACCESS_KEYS_CREATE_FAILURE:
    case ACCESS_KEYS_DELETE_FAILURE:
      newState = entityHandlers.crudErrorHandler(state, action);
      break;
    case ACCESS_KEYS_DISABLE_CONFIRMATION_SHOW:
      newState = update.set(state, 'selectedAccessKey', action.payload);
      newState = update.set(newState, 'showDisableConfirmation', true);
      break;
    case ACCESS_KEYS_DISABLE_CONFIRMATION_HIDE:
  newState = update.set(state, 'showDisableConfirmation', false);
  newState = update.set(newState, 'selectedAccessKey', null);
      break;
  }
  return newState;
};

export default accessKeyReducer;
